import React from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { Paper, Typography } from '@mui/material';
import { PlayArrow as StartIcon } from '@mui/icons-material';
import { WorkflowNode } from '../../../../types/workflow.types';

const StartNode: React.FC<NodeProps<WorkflowNode['data']>> = ({ data, selected }) => {
  return (
    <Paper
      elevation={selected ? 8 : 2}
      style={{
        padding: 16,
        minWidth: 120,
        backgroundColor: '#4CAF50',
        color: 'white',
        border: selected ? '3px solid #1976d2' : '1px solid #388E3C',
        borderRadius: 8,
        cursor: 'pointer',
        transition: 'all 0.2s ease-in-out',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
        <StartIcon style={{ fontSize: 20 }} />
        <Typography variant="subtitle2" fontWeight="bold">
          {data?.title || 'Start'}
        </Typography>
      </div>

      {data?.description && (
        <Typography variant="caption" style={{ opacity: 0.9, fontSize: '0.7rem' }}>
          {data?.description}
        </Typography>
      )}

      <div style={{ marginTop: 8, display: 'flex', justifyContent: 'center' }}>
        <Typography variant="caption" style={{ opacity: 0.8, fontSize: '0.65rem' }}>
          Workflow Entry Point
        </Typography>
      </div>

      {/* Output handle */}
      <Handle
        type="source"
        position={Position.Right}
        style={{
          backgroundColor: '#2E7D32',
          border: '2px solid white',
          width: 12,
          height: 12,
        }}
      />
    </Paper>
  );
};

export default StartNode;